import { checkValue } from "../../../../functions/checkValue";
import {
  UserDetailItem,
  UserDetailsWrapper,
  UserInfoBoxTitle,
  UserBoxWrapper,
} from "./UserDialogUi";
const AccountInfo = ({ userData }) => {
  return (
    <UserBoxWrapper>
      <UserInfoBoxTitle title="Account Info" />
      <UserDetailsWrapper>
        <UserDetailItem label="Account Number" value={userData.accountNumber} />
        <UserDetailItem label="IFSC Code" value={userData.ifsc} />
      </UserDetailsWrapper>
      <UserDetailsWrapper>
        <UserDetailItem
          label="Bank Name"
          value={checkValue(userData.bankName?.name)}
        />
        <UserDetailItem label="Bank Branch" value={userData.bankBranch} />
      </UserDetailsWrapper>
    </UserBoxWrapper>
  );
};

export default AccountInfo;
